import {
    CheckoutLifecycleEventPostMessageName,
    checkoutPostMessage,
} from '@eventbrite/checkout-postmessage-api';
import { updateStatsigUserMetadata } from '../../statsig';
import { getPostMessageActionParamsFromState } from '../utils';
import { handleUpdateOrder } from './handleUpdateOrder';

export const initializeOrder = (orderState) => async (dispatch, getState) => {
    const state = getState();
    const { eventId, widgetParentUrl } =
        getPostMessageActionParamsFromState(state);

    await handleUpdateOrder(dispatch, orderState);

    await dispatch(updateStatsigUserMetadata);

    checkoutPostMessage({
        messageName: CheckoutLifecycleEventPostMessageName.orderStart,
        eventId,
        widgetParentUrl,
    });
};
